export default __webpack_public_path__ + "static/assets/7911235b3ccae7b7452ba3da6b5e9c7f.svg";